
import axios from '@/util/requestUtil'

// 查询所有银行信息-其他列表上用
export function getAllBank (params) {
  return axios.get(`/fund/allBank`, { params: params })
}

// 基金-风险评测题目
export function riskQuestions (params) {
  return axios.get(`/trade/fundCash/risk/assessment/questions`, { params: params })
}

// 基金-提交-风险评测
export function fundCashRiskAssessment (params) {
  return axios.post(`/trade/fundCash/submit/fundCashRiskAssessment`, params)
}

// 基金-风险评测题目
export function riskStatus (params) {
  return axios.get(`/trade/fundCash/query/fundCashRiskAssessment/status`, { params: params })
}

// 基金-查询-风险评测-结果
export function getRiskLevel (params) {
  return axios.get(`/trade/fundCash/query/fundCashRiskAssessment/result`, { params: params })
}

// 基金-风险评测-确认结果无误
export function fundCashRiskAgreement (params) {
  return axios.post(`/trade/fundCash/submit/fundCashRiskAssessment/agreement`, params)
}

// 我的银行卡-其他银行卡-查询是否禁止出金
export function queryWithdrawalLimit(params) {
  return axios.get(`/fund/withdrawal/queryWithdrawalLimit`, { params: params })
}
// 货币手续费
export function getHandingCharge(params) {
  return axios.get(`/charge/handingCharge`, { params })
}
// 查询风险问卷答题次数
export function getTotalAttempts () {
  return axios.get('/trade/fundCash/getTotalAttempts')
}

export function getOpenAccountStatus (params) {
  return axios.get('/trade/fundCash/query/fundCashStatus', { params })
}
